module.exports = __webpack_public_path__ + "img/arrow_left_circle.43e12f54.svg";